import styles from './LegalPage.module.css';

export function PrivacyPage() {
  return (
    <div className={styles.page}>
      <h1 className={styles.heading}>Privacy Policy</h1>
      <p className={styles.subheading}>Last updated: July 26, 2026</p>

      <section className={styles.section}>
        <h2>Who we are</h2>
        <p>
          WhaleTail is operated by Reints Labs LLC, an Iowa limited liability company
          (&ldquo;Reints Labs,&rdquo; &ldquo;we,&rdquo; &ldquo;us,&rdquo; or
          &ldquo;our&rdquo;). This policy explains what data WhaleTail handles and why.
        </p>
      </section>

      <section className={styles.section}>
        <h2>What we don't collect</h2>
        <p>
          WhaleTail does not require an account, does not use cookies for tracking or
          advertising, does not run analytics or ad trackers, and does not collect names,
          email addresses, or payment information. We never ask for private keys, seed
          phrases, wallet signatures, or exchange credentials.
        </p>
      </section>

      <section className={styles.section}>
        <h2>What is stored, and where</h2>
        <p>
          The Bitcoin address and label you choose to track, along with the last
          successful wallet summary for that address, are stored only in your
          browser&apos;s <code>localStorage</code> (or, for the Scriptable client, a local
          cache file on your device). This is used solely to show a &ldquo;since your last
          visit&rdquo; comparison and to display recent data if a live lookup temporarily
          fails. This data is never transmitted to Reints Labs LLC and never leaves your
          device except in the ordinary course of your browser making the API requests
          described below.
        </p>
      </section>

      <section className={styles.section}>
        <h2>Requests to our API</h2>
        <p>
          When you load WhaleTail, your browser calls our own <code>/api/*</code>{' '}
          endpoints, which in turn query the public Blockstream and CoinGecko APIs on your
          behalf using the Bitcoin address you provide. Standard web server logs (such as
          IP address and request timing, as retained by our hosting provider, Netlify) may
          exist for operational and security purposes, but we do not use them to build a
          profile of you, and we do not sell or share this information with third parties
          for marketing purposes.
        </p>
      </section>

      <section className={styles.section}>
        <h2>Third-party services</h2>
        <p>
          WhaleTail's server-side functions call Blockstream (blockstream.info) and
          CoinGecko (coingecko.com) to retrieve public blockchain and market data. Those
          services have their own privacy practices, which we do not control. The Bitcoin
          address you look up is, by the nature of a public blockchain, already public
          information.
        </p>
      </section>

      <section className={styles.section}>
        <h2>Children's privacy</h2>
        <p>
          WhaleTail is not directed to children under 13, and we do not knowingly collect
          personal information from children.
        </p>
      </section>

      <section className={styles.section}>
        <h2>Changes to this policy</h2>
        <p>
          We may update this policy from time to time. Continued use of the Site after an
          update constitutes acceptance of the revised policy.
        </p>
      </section>

      <section className={styles.section}>
        <h2>Contact</h2>
        <p>
          Questions about this policy can be sent to{' '}
          <a href="mailto:sales@reintslabs.com">sales@reintslabs.com</a>.
        </p>
      </section>
    </div>
  );
}
